<ng-container *translateBlock="let t">
  @if (formData.formGroup) {
    <div class="input-wrapper"
         [formGroup]="formData.formGroup"
         xmlns="http://www.w3.org/1999/html">
      @if (isLoading) {
        <p-skeleton height="50px"
                    class="mb-2" />

        <label [for]="formData.id"
               class="label skeletonLabel">
          {{ t(formData.label) }}
        </label>
      } @else {
        <p-floatlabel class="w-full md:w-56"
                      variant="on">
          <p-datepicker [formControlName]="formData.id"
                        [inputId]="formData.id"
                        [selectionMode]="selectionMode"
                        [readonlyInput]="readonlyInput"
                        [showIcon]="showIcon"
                        [dateFormat]="dateFormat"
                        [placeholder]="formData.placeholder ? t(formData.placeholder) : ''"
                        [minDate]="formData.minDate"
                        [maxDate]="formData.maxDate"
                        [showTime]="formData.showTime || false"
                        [showButtonBar]="formData.showButtonBar || false"
                        [appendTo]="formData.appendTo"
                        [baseZIndex]="formData.baseZIndex"
                        [size]="formData.size"
                        [style]="datePickerRootStyle"
                        [inputStyle]="datePickerInputStyle"
                        [panelStyle]="datePickerPanelStyle"
                        class="w-full"></p-datepicker>

          <label class="on_label"
                 for="{{ formData.id }}">
            {{ t(formData.label) }}
          </label>
        </p-floatlabel>
      }

      @if (formData.iconLeft) {
        <span class="material-symbols-rounded icon-left">
        {{ formData.iconLeft }}
      </span>
      }
    </div>
  } @else {
    <div class="input-wrapper">
      @if (isLoading) {
        <p-skeleton height="50px"
                    class="mb-2" />

        <label [for]="formData.id"
               class="label skeletonLabel">
          {{ t(formData.label) }}
        </label>
      } @else {
        <p-floatlabel class="w-full md:w-56"
                      variant="on">
          <p-datepicker [ngModel]="value"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onStandaloneValueChange($event)"
                        [inputId]="formData.id"
                        [selectionMode]="selectionMode"
                        [readonlyInput]="readonlyInput"
                        [showIcon]="showIcon"
                        [dateFormat]="dateFormat"
                        [placeholder]="formData.placeholder ? t(formData.placeholder) : ''"
                        [minDate]="formData.minDate"
                        [maxDate]="formData.maxDate"
                        [showTime]="formData.showTime || false"
                        [showButtonBar]="formData.showButtonBar || false"
                        [appendTo]="formData.appendTo"
                        [baseZIndex]="formData.baseZIndex"
                        [size]="formData.size"
                        [disabled]="disabled"
                        [style]="datePickerRootStyle"
                        [inputStyle]="datePickerInputStyle"
                        [panelStyle]="datePickerPanelStyle"
                        class="w-full"></p-datepicker>

          <label class="on_label"
                 for="{{ formData.id }}">
            {{ t(formData.label) }}
          </label>
        </p-floatlabel>
      }

      @if (formData.iconLeft) {
        <span class="material-symbols-rounded icon-left">
        {{ formData.iconLeft }}
      </span>
      }
    </div>
  }

  @if (formData.required && checkError()) {
    <p class="message error">
      {{ t('common.messages.error.required') }}
    </p>
  }

  @if (formData.infoText) {
    <p class="message info">
      {{ t(formData.infoText) }}
    </p>
  }
</ng-container>
